<template>
	<div id="navBar" class="shadow-md z-40" style="position: fixed;width: 100%;">
		<div class="h-full flex justify-between">
			<div class="flex items-center justify-between w-80 xl:w-64">
				<div v-if="isMobileView" class="py-4 px-4 cursor-pointer" @click="toggleMenu">
					<font-awesome-icon icon="bars" class="" />
				</div>

				<router-link :to="{ name: 'Dashboard' }" class="w-full">
					<div class="flex items-center justify-start w-full">
						<img class="px-4 w-full h-full" src="../../assets/logo.svg" alt="IMD-CONNECT.PRO" />
					</div>
				</router-link>
			</div>

			<!--      TODO: do we need this?!-->
			<!--			<BaseSelect @input="storeCurrentGroup" class="w-64 mr-8 mt-2" v-model="optionSelect" :options="options" v-if="isEmulateLevel" />-->
			<!--			<div class=" pt-4 font-bold" v-else-if="optionSelect">Level: {{ optionSelect.value }}</div>-->

			<div v-if="isEmulateLevel" class=" text-xs pointer-events-none">
				<div>{{ $t('company_input') }} {{ $store.getters.getUser.person.company.name }}</div>
				<div>{{ $t('group_input') }} {{ $store.getters.getUser.usergroup.name }}</div>
				<div>{{ $t('person_input') }} {{ $store.getters.getUser.person.firstName }} {{ $store.getters.getUser.person.lastName }}</div>
			</div>

			<div class="flex">
				<router-link
					:to="{ name: 'notifications' }"
					class="parent"
					@click.native="$route.name === 'notifications'"
					v-if="this.$store.getters.getUser.onboarding.completed"
				>
					<NotificationBell :count="$store.getters.getUnreadNotificationCount" />
					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">{{ getNotificationHoverText }}</div>
				</router-link>

				<router-link class="parent" :to="{ name: 'AccountSettings' }">
					<font-awesome-icon icon="cog" :title="$t('settings').toString()" class=" my-4 mx-8 h-6 w-6 cursor-pointer" style="font-size: 25px" />
					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">{{ $t('settings') }}</div>
				</router-link>

				<router-link class="parent" :to="{ name: 'Userprofile' }" v-if="this.$store.getters.getUser.onboarding.completed">
					<font-awesome-icon icon="user" :title="this.fullname" class=" my-4 mx-8 h-6 w-6 cursor-pointer" style="font-size: 25px" />
					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">{{ this.fullname }}</div>
				</router-link>
				<div v-if="!isUserAllowedInLevel1">
					<font-awesome-icon
						icon="question-circle"
						:title="$t('help').toString()"
						class=" my-4 mx-8 h-6 w-6 cursor-pointer"
						style="font-size: 25px"
						@click="setHelpContact"
					/>
					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">{{ $t('help') }}</div>
				</div>

				<!--				<div @click="reportClientLogs" class="parent" v-if="$store.getters.getLogs && $store.getters.getLogs.length">-->
				<!--					<font-awesome-icon icon="bug" class=" my-4 mx-8 h-6 w-6 cursor-pointer" style="font-size: 25px" />-->
				<!--					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">Bugreport senden</div>-->
				<!--				</div>-->

				<div @click="logout" class="parent">
					<font-awesome-icon icon="sign-out-alt" class=" my-4 mx-8 h-6 w-6 cursor-pointer" style="font-size: 25px" />
					<div class="hidden absolute rounded p-2 h-4 mx-1 text-white parent-hover:show">{{ $t('log_out') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getOptionFromOptionsArray } from '@/plugins/Utils';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import NotificationBell from '@/components/misc/NotificationBell';
import Authentication from '@/mixins/Authentication';
import PremiumBadge from '@/components/misc/premium-lawyer-badge.vue';

export default {
	name: 'NavigationBar',
	components: { PremiumBadge, BaseSelect, NotificationBell },
	mixins: [Authentication],
	props: {
		menuOpened: {},
	},
	data() {
		return {
			options: [
				{ display: 'Level 1', value: '1' },
				{ display: 'Level 2', value: '2' },
				{ display: 'Level 3', value: '3' },
				{ display: 'Level 4', value: '4' },
				{ display: 'Level 5', value: '5' },
				{ display: 'Level 6', value: '6' },
				{ display: 'Level 7', value: '7' },
				{ display: 'Level 8', value: '8' },
			],
		};
	},
	methods: {
		reportClientLogs() {
			this.$store.dispatch('reportLogs').then(() => {
				this.$swal('Danke!', 'Der Bericht wurde übertragen und wir werden uns bald darum kümmern.');
			});
		},
		toggleMenu() {
			this.$emit('toggleMenu', !this.menuOpened);
		},
		storeCurrentGroup($event) {
			this.$store.commit('setAuthenticatedUserLevel', $event.value);
		},
		logout() {
			const confirmLeaving = this.$store.getters.getConfirmLeaving;
			if (confirmLeaving !== false) {
				const result = confirm(this.$t('leave_page'));
				if (result) {
					this.$store.commit('setConfirmLeaving', false);
					this.$store.dispatch('stopLoopUpdateNotifications');
					this.$store.dispatch('logout');
				}
			} else {
				this.$store.dispatch('stopLoopUpdateNotifications');
				this.$store.dispatch('logout');
			}
		},
		formatedNotificationHoverText() {
			const notificationCount = this.$store.getters.getUnreadNotificationCount;
			if (notificationCount === 1) {
				return this.$t('new_notification').toString();
			}
			return this.$t('new_notifications', { count: notificationCount });
		},
		setHelpContact() {
			this.$store.commit('setIsShowHelpModal', true);
		},
	},
	computed: {
		getNotificationHoverText() {
			return this.formatedNotificationHoverText();
		},
		isMobileView() {
			return this.$store.getters.getIsMobileView;
		},
		optionSelect() {
			return getOptionFromOptionsArray(this.options, this.getAuthenticatedUserGroupLevel);
		},
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
		isEmulateLevel() {
			return process.env.VUE_APP_EMULATE_LEVEL === '1';
		},
		fullname() {
			return this.$store.getters.getUser.person?.firstName + ' ' + this.$store.getters.getUser.person?.lastName;
		},
	},
};
</script>

<style lang="sass" scoped>
#navBar
	height: calc(#{$navbar_height} - 1px)
	background: #cdd2dd

span
  background-color: $sp_blue
  color: white

hover-trigger hover-target
    display: none

hover-trigger:hover hover-target
    display: block

.logoGradient
	background: $sp_blue;
	background: linear-gradient(90deg, $sp_blue 0%, #ffffff 30%, #ffffff 45%, $sp_blue 100%)
</style>

<style lang="sass">
.notification-counter
  width: auto !important
</style>

<style scoped>
.parent:hover .parent-hover\:show {
	background-color: #333;
	display: block;
	height: initial !important;
}
</style>
